import { openInBlobInBlank } from "../../../../../common/utils/view_utils";
import { IDownloadBoletoAvaliacaoOrdemCompraUseCase } from "../../../presentation/useCases/read/download_boleto_avaliacao_ordem_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DownloadBoletoAvaliacaoOrdemCompraUseCase
 */

export class DownloadBoletoAvaliacaoOrdemCompraUseCase implements IDownloadBoletoAvaliacaoOrdemCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async downloadBoletoAvaliacaoOrdemCompra(
    idOrdemCompra: number,
    nomeArquivo: string,
  ): Promise<void> {
    const results = await this.repository.downloadBoletoAvaliacaoOrdemCompra(idOrdemCompra);
    await openInBlobInBlank(nomeArquivo, results);
  }
}
